/**
 * Will add any new filter options to an existing filter section.
 *
 * Does not update the fixed values. These can only be defined when initially creating the filter section.
 */
export const updateFilterSection = (filterSection, filterOptions) => {
    const existingOptions = filterSection.options.filter(option => isExistingOptionValid(filterOptions, option));
    const newOptions = filterOptions.filter(option => isNewFilterOption(filterSection, option));
    filterSection.options = [...existingOptions, ...newOptions];
};
/**
 * Given an existing filter section, determines whether an option is new.
 *
 * An option will be new if it doesn't already exist in the filter options or fixed values.
 */
const isNewFilterOption = (filterSection, filterOption) => {
    return (!filterSection.options.some(option => option.value === filterOption.value) &&
        !filterSection.fixed.includes(filterOption.value));
};
/**
 * Given a new set of filter options, determines whether an existing option is still valid.
 *
 * An existing option will be valid if it is selected or included in the new set of options.
 * We retain any selected options so that they do not disappear if the underlying data changes.
 */
const isExistingOptionValid = (filterOptions, filterOption) => {
    return filterOption.selected || filterOptions.some(option => option.value === filterOption.value);
};
